import { AnswerModel } from 'core/models/elements/answers/answer.abstract.model';

import { pascalToCamel } from 'utils/common.util';

/**
 * @class Defines an scorm answer corresponding to an scorm question.
 */
export class LtiQuestionAnswerModel extends AnswerModel {
  /**
   * @constructor Creates an instance of an scorm answer built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.scaledScore = bo.ScaledScore || bo.scaledScore;
    this.isSuccessful = bo.IsSuccessful || bo.isSuccessful;
    this.ltiResults = bo.lti_results;
  }

  static instantiateFromApi(data) {
    const bo = pascalToCamel(data);
    return new LtiQuestionAnswerModel(bo);
  }
}
